import SelectedSensorList from './SelectedSensorList';
import { StyledBox } from './SensorAnalysis.styles';
import SensorAnalysisCharts from './SensorAnalysisCharts';
import { SensorSelector } from './SensorSelector';

export const SensorAnalysisMainContent = () => {
  return (
    <StyledBox>
      <SensorSelector />
      <SelectedSensorList />
      <SensorAnalysisCharts />
    </StyledBox>
  );
};

export default SensorAnalysisMainContent;
